module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[91]456.3086766.woff2";